import m from "../../geodata/es2015/somaliaHigh";
window.am4geodata_somaliaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/somaliaHigh.js
// module id = null
// module chunks = 